export const doesStringContainPeriod = (fieldName: string) => {
  return fieldName.includes('.');
};
